import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;

export const TIMEZONES = [
  { value: 'Pacific/Honolulu',     label: '(UTC−10:00) Hawaii — Honolulu' },
  { value: 'America/Anchorage',    label: '(UTC−09:00) Alaska — Anchorage' },
  { value: 'America/Los_Angeles',  label: '(UTC−08:00) Pacific Time — Los Angeles' },
  { value: 'America/Denver',       label: '(UTC−07:00) Mountain Time — Denver' },
  { value: 'America/Chicago',      label: '(UTC−06:00) Central Time — Chicago' },
  { value: 'America/New_York',     label: '(UTC−05:00) Eastern Time — New York' },
  { value: 'America/Halifax',      label: '(UTC−04:00) Atlantic Time — Halifax' },
  { value: 'America/St_Johns',     label: '(UTC−03:30) Newfoundland — St. John’s' },
  { value: 'America/Sao_Paulo',    label: '(UTC−03:00) Argentina / Eastern Brazil' },
  { value: 'Europe/London',        label: '(UTC±00:00) Western European Time — London' },
  { value: 'Europe/Paris',         label: '(UTC+01:00) Central European Time — Paris, Berlin' },
  { value: 'Europe/Athens',        label: '(UTC+02:00) Eastern European Time — Athens' },
  { value: 'Europe/Istanbul',      label: '(UTC+03:00) Moscow / Turkey — Istanbul' },
];
